import { Gender } from '@app/graphql/types'
import { ICustomer } from '@app/modules/Messages/store/models'

export const customerSalutation = (customer: ICustomer): string => {
  switch (customer.gender) {
    case Gender.F:
      return `Sehr geehrte Frau ${customer.lastName},`
    case Gender.M:
      return `Sehr geehrter Herr ${customer.lastName},`
    case Gender.D:
      return `Guten Tag ${customer.firstName} ${customer.lastName},`
    default:
      return ''
  }
}
